<template>
  <v-card width="298" height="536" class="sigfloCard sigfloNeutralBorder200 elevation-0">
    <external-product-dialog
      :url="product.detailsSource"
      :showDialog="showDetailsDialog"
      @close="showDetailsDialog = false"
    ></external-product-dialog>
    <v-card-text>
      <product-image-carousel
        :product="product"
        :carouselHeight="250"
        :carouselWidth="250"
        :allowCarouselDialog="true"
      />
      <div class="productTextContainer">
        <div class="productName sigfloBody600 textDefault mb-1 pb-0">
          {{ product.name }}
        </div>
        <!-- <div class="productSku sigfloBodySmall400 textDefault">
          {{ product.sku }}
        </div> -->
        <div :class="productDescriptionClass" class="productDescription sigfloBodySmall400 textMuted">
          <v-tooltip bottom max-width="500">
            <template v-slot:activator="{ on, attrs }">
              <span class="textMuted" v-bind="attrs" v-on="on">{{ product.description }}</span>
            </template>
            <span class="">{{ product.description }}</span>
          </v-tooltip>
          <br />
          <v-tooltip right max-width="500">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" v-html="product.specifications"></span>
            </template>
            <span v-html="product.specifications"></span>
          </v-tooltip>
        </div>
      </div>
      <div class="">
        <v-btn
          @click="showDetails"
          v-show="product.detailsSource"
          rounded
          color="#F4F2F7"
          class="sigfloButtonSmall600 textEmphasis elevation-0 text-capitalize mx-4 mb-1"
          >View Details</v-btn
        >
      </div>
    </v-card-text>
    <v-divider class="mt-0 px-4" />
    <v-card-actions class="productActions mx-1 pt-3">
      <span class="productPrice textEmphasis sigfloBodyLarge" v-if="!productHasPriceRange(product)"
        >${{ formatPrice(product.sellPrice) }}</span
      >
      <span class="productPrice textEmphasis sigfloBodyLarge" v-if="productHasPriceRange(product)">{{
        getPriceRange(product)
      }}</span>
      <v-spacer />
      <v-btn
        rounded
        dark
        class="text-capitalize sigfloButtonSmall600 elevation-0 px-4"
        color="#7C40DC"
        @click="selectProduct()"
        >Select<v-icon class="ml-2">mdi-arrow-right</v-icon></v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';
  import externalProductDialog from '../../shared/ExternalProductDialog.vue';

  export default {
    components: {
      productImageCarousel: () => import('./ProductImageCarousel.vue'),
      externalProductDialog
    },
    props: {
      product: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapState(['configurator']),
      productDescriptionClass() {
        if (!this.product.detailsSource) {
          return 'productDescriptionLonger';
        }
        return '';
      }
    },
    data() {
      return {
        showDetailsDialog: false
      };
    },
    methods: {
      /**
       * Opens the details url of the product in an iframe
       */
      showDetails: function () {
        this.showDetailsDialog = true;
      },
      /**
       * Marks this product as selected in the step
       */
      selectProduct: function () {
        const selected = !this.product.selected;
        this.$store.commit('configurator/selectProduct', {
          productId: this.product.id,
          selected: selected
        });
        this.$store.commit('configurator/incrementSubsystemKey');
        this.saveSubsystemStepProgress('subsystem');
        this.$store
          .dispatch('configurator/raiseSigEvent', {
            parentType: 'Product',
            parentEvent: 'Select',
            parentId: this.product.id
          })
          .then((sigMsg) => {
            if (sigMsg) {
              this.processSigResponse(sigMsg);
            }
          });
      }
    }
  };
</script>

<style scoped>
  .productTextContainer {
    padding-top: 16px;
    padding-bottom: 16px;
    padding-left: 16px;
    padding-right: 16px;
  }
  .productName {
    padding-bottom: 8px;
    overflow: hidden;
    text-wrap: nowrap;
    text-overflow: ellipsis;
  }
  .productSku {
    padding-bottom: 8px;
  }
  .productActions {
    padding-top: 0px;
    padding-bottom: 16px;
  }
  .productDescription {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    line-height: 1.5; /* Adjust line height as needed */
    height: 89px;
    margin-bottom: 2px;
  }
  .productDescriptionLonger {
    height: 131px;
    -webkit-line-clamp: 6;
    margin-bottom: 0px;
  }
</style>
